import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import ProductDetails from "./pages/ProductDetails";

import Sidebar from "./components/Sidebar";
import CheckoutPage from "./pages/CheckoutPage";
import ThankYouPage from "./pages/ThankYouOrder";

const App = () => {
  return (
    <div className="overflow-hidden">
      <Router>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/product/:slug" element={<ProductDetails />}></Route>
          <Route path="/checkout" element={<CheckoutPage />}></Route>
          <Route path="/thank-you" element={<ThankYouPage />}></Route>
          <Route path="*" element={<Home />}></Route>
        </Routes>
        <Sidebar />
        {/* <Footer /> */}
      </Router>
    </div>
  );
};

export default App;
